import { storage } from '@/plugins/ionic-storage';
import { postRequest } from '@/utils/request';
// import { getIMToken, getIMUserID } from '@/utils/storage';
import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';

/**
 * 访问令牌
 *
 * TToken
 */
export interface TToken {
  /**
   * 访问令牌
   */
  accessToken?: string;
  /**
   * 客户端编号
   *
   * 关联{@link OAuth2ClientDO#getId()}
   */
  clientId?: string;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 创建者，目前使用 SysUser 的 id 编号
   *
   * 使用 String 类型的原因是，未来可能会存在非数值的情况，留好拓展性。
   */
  creator?: string;
  /**
   * 是否删除
   */
  deleted?: boolean;
  /**
   * 过期时间
   */
  expiresTime?: string;
  /**
   * 编号，数据库递增
   */
  id?: number;
  /**
   * 刷新令牌
   */
  refreshToken?: string;
  /**
   * 授权范围
   */
  scopes?: string[];
  /**
   * 更新者，目前使用 SysUser 的 id 编号
   *
   * 使用 String 类型的原因是，未来可能会存在非数值的情况，留好拓展性。
   */
  updater?: string;
  /**
   * 最后更新时间
   */
  updateTime?: string;
  /**
   * 用户编号
   */
  userId?: number;
  /**
   * 用户信息
   */
  userInfo?: {
    [key: string]: any;
  };
  /**
   * 用户类型
   *
   * 枚举{@link UserTypeEnum}
   */
  userType?: number;
  [property: string]: any;
}

export const useTokenStore = defineStore('token', () => {
  const token = reactive<TToken>({});
  const isTokenRefreshing = ref(false); // 是否正在刷新令牌
  let refreshTokenPromise: Promise<void> | null = null;
  const setData = (data: TToken) => {
    for (const key in data) {
      token[key] = data[key];
    }
    // token.IMUserID = data.userInfo?.openIMUserId;
    // token.IMToken = data.userInfo?.openIMToken;

    ['accessToken', 'refreshToken'].forEach((key) => {
      token[key] && storage.set(key, token[key]);
    });
  };

  const initialToken = async () => {
    const tokenStr = await storage.get('user');
    if (tokenStr) {
      return JSON.parse(tokenStr);
    }
  };

  // 同步用户信息，从本地存储中获取
  const syncToken = async () => {
    const data = await initialToken();
    for (const key in data) {
      token[key] = data[key];
    }

    const accessToken = await storage.get('accessToken');
    const refreshToken = await storage.get('refreshToken');
    token.accessToken = accessToken;
    token.refreshToken = refreshToken;
    // token.IMToken = await getIMToken();
    // token.IMUserID = await getIMUserID();
  };

  const getToken = () => token;
  const refreshTokenFn = async () => {
    if (refreshTokenPromise) return refreshTokenPromise;
    isTokenRefreshing.value = true;
    refreshTokenPromise = (async () => {
      const res = await postRequest(
        '/users/refresh-token',
        {},
        {
          skipAuthRefresh: true, // 跳过刷新令牌
          params: {
            refreshToken:
              token.refreshToken ||
              (await storage.get('refreshToken')),
          },
        },
      );

      setData(res);
    })().finally(() => {
      isTokenRefreshing.value = false;
      refreshTokenPromise = null;
    });
    return refreshTokenPromise;
  }
  const clearToken = async () => {
    token.accessToken = '';
    token.refreshToken = '';
    await storage.remove('accessToken');
    await storage.remove('refreshToken');
  }

  // syncToken();
  return { token, setData, clearToken, getToken, syncToken, isTokenRefreshing, refreshTokenFn };
});
